import PropTypes from 'prop-types'
import React from 'react'
import { PermissionLevels } from 'utils/permission'
import { FormattedMessage } from 'react-intl'
import {
  Button
} from 'react-bootstrap'
import KanBoPicker from 'components/KanBoPicker'

export class Move extends React.Component {
  static propTypes = {
    onMove: PropTypes.func.isRequired
  }

  state = {
    boardId: null,
    statusId: null,
  }

  handleBoardChange = (boardId) => {
    this.setState({
      boardId,
    })
  }

  handleStatusChange = (statusId) => {
    this.setState({
      statusId,
    })
  }

  handleMoveClick = () => {
    const {
      onMove
    } = this.props

    onMove({
      boardId: this.state.boardId,
      statusId: this.state.statusId,
    })
  }

  render () {
    const {
      onMove, // eslint-disable-line no-unused-vars

      ...props
    } = this.props
    const {
      statusId
    } = this.state

    return (
      <React.Fragment>
        <KanBoPicker
          {...props}
          board
          status
          requiredPermissionLevel={PermissionLevels.MEMBER}
          onBoardChange={this.handleBoardChange}
          onStatusChange={this.handleStatusChange}
        />
        <Button
          bsStyle='primary'
          disabled={!statusId}
          onClick={this.handleMoveClick}
        >
          <FormattedMessage id='CARD_MOVE_HEADER' />
        </Button>
      </React.Fragment>
    )
  }
}

export default Move

